// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.editUser_dashboard__yUISc {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.editUser_dashboardContain__GtVNk {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.editUser_bodythemedark__gJc0k .editUser_dashboardContain__GtVNk,
.editUser_bodythemedark__gJc0k .editUser_dashboard__yUISc,
.editUser_bodythemedark__gJc0k .editUser_cont2__WDGNX {
  background-Color: #0f1824;
}

.editUser_top_header__7A80O .editUser_top_header_inner__2GMP0 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.editUser_cont2__WDGNX {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.editUser_footer__arSK6 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.editUser_bodythemelight__KB6by {
  background-color: #fff;
  padding-top: 90px;
}

.editUser_bodythemedark__gJc0k {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.editUser_headerthemelight__RcR6X {
  background-color: #fff;
}

.editUser_headerthemedark__1XW9I {
  background-color: #132337;
}

.editUser_top_header__7A80O {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.editUser_menuthemelight__93STk {
  background-color: #fff;
}

.editUser_menuthemedark__yR0K2 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.editUser_menulinklight__T1Ugp span {
  color: #666666 !important;
}

.editUser_menulinklight__T1Ugp a {
  color: #CBCBCB !important;
}

.editUser_menulinklight__T1Ugp:hover span, .editUser_menulinklight__T1Ugp:hover a {
  color: #fff !important;
}

.editUser_menulinkdarkSelected__bZWxL {
  background-color: #1c2e45;
  color: #3b82f6;
}

.editUser_menuthemelight__93STk .editUser_menulinklightSelected__LxANp {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.editUser_menulinkdark__4Mzbh {
  color: #92afd3 !important;
}

.editUser_menulinklight__T1Ugp:hover {
  color: #fff !important;
  background-color: #131F43;
}

.editUser_menulinklight__T1Ugp .editUser_sub_arrow__valJj svg path {
  stroke: #CBCBCB !important;
}

.editUser_menulinklight__T1Ugp:hover .editUser_sub_arrow__valJj svg path {
  stroke: #fff !important;
}

.editUser_menulinkdark__4Mzbh .editUser_sub_arrow__valJj svg path {
  stroke: #92afd3 !important;
}

.editUser_menulinkdark__4Mzbh:hover .editUser_sub_arrow__valJj svg path {
  stroke: #fff !important;
}

.editUser_menulinkdark__4Mzbh:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.editUser_headinglight__iYkug {
  color: #60677e;
}

.editUser_headingdark__CC5Nk {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.editUser_searchboxlight__JtJHv {
  background-color: #fff;
  border: none;
}

.editUser_searchboxdark__c8WH1 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.editUser_searchboxdark__c8WH1::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.editUser_tableheadlight__t32QY {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.editUser_tableheadlight__t32QY th {
  color: #fff;
}

thead .editUser_tableheadlight__t32QY th:first-child,
thead .editUser_tableheaddark__IU1BY th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .editUser_tableheadlight__t32QY th:last-child,
thead .editUser_tableheaddark__IU1BY th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.editUser_table__UBG50.editUser_table-borderless__vgOBj {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.editUser_tableheaddark__IU1BY {
  background-color: #132337;
  color: #fff;
}

.editUser_table-borderless__vgOBj tr:nth-child(even) {
  background-color: #F9FAFB;
}

.editUser_table-borderless__vgOBj .editUser_left-section__5Ygpr {
  padding-top: 10px;
}

.editUser_tablebodylight__xGR7k td,
.editUser_tablebodydark__ANb75 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.editUser_tablebodylight__xGR7k {
  background-color: #fff;
}
.editUser_tablebodylight__xGR7k:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.editUser_tablebodydark__ANb75 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.editUser_tablebodydark__ANb75:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.editUser_paginationlight__UynJG {
  color: #60677e !important;
  font-size: 13px !important;
}

.editUser_paginationdark__EfSxZ {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.editUser_formthemelight__\\+6R3K {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.editUser_formthemedark__91io7 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.editUser_formthemedark__91io7 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.editUser_viewformlight__y32\\+k {
  background-color: #f3f6f9;
}

.editUser_permissionboxlight__uvNqc {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.editUser_permissionboxdark__bgl1b {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.editUser_errormsgclr__vFQxR {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.editUser_graphclrlight__0tGaV {
  background-color: #fff;
}

.editUser_graphclrdark__Oe4fN {
  background-color: #132337;
}

/* 
Counter theme
*/
#editUser_card1bglight__kUxQl {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#editUser_card1bgdark__tfYHD {
  background: #392f28;
}

#editUser_card2bglight__ZXiVd {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#editUser_card2bgdark__O1gIJ {
  background: #1c3238;
}

#editUser_card3bglight__xkw1U {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#editUser_card3bgdark__FCvDO {
  background: #3a2434;
}

#editUser_card4bglight__pic05 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#editUser_card4bgdark__oir3Z {
  background: #2f264f;
}

#editUser_card1bgdark__tfYHD a, #editUser_card1bgdark__tfYHD p,
#editUser_card2bgdark__O1gIJ a, #editUser_card2bgdark__O1gIJ p,
#editUser_card3bgdark__FCvDO a, #editUser_card3bgdark__FCvDO p,
#editUser_card4bgdark__oir3Z a, #editUser_card4bgdark__oir3Z p {
  color: #fff;
}

/* 
Action button theme
*/
.editUser_actionbtnlight__3hMAT {
  color: rgba(70, 71, 91, 0.8705882353);
}

.editUser_actionbtnlight__3hMAT:hover {
  cursor: pointer;
}

.editUser_actionbtndark__c1n4B {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.editUser_profiledropdownlight__zqmBO {
  background-color: #fff;
}

.editUser_profiledropdowndark__WK9BI {
  background-color: #151521;
}

.editUser_settingsection__qkXU0 #editUser_addform__ovjfH.editUser_formthemedark__91io7 .editUser_savebtn__RGuGY {
  background-color: #3b82f6;
  color: #fff;
}

#editUser_addform__ovjfH.editUser_formthemedark__91io7 .editUser_savebtn__RGuGY {
  background-color: #3b82f6;
  color: #fff;
}

.editUser_profile_conatiner__4m7UK {
  border-radius: 5px !important;
}

.editUser_bodythemedark__gJc0k .editUser_ag-theme-alpine__hlul9 .editUser_ag-row__uJXdt {
  background: #000 !important;
}

.editUser_bodythemedark__gJc0k .editUser_formbtn__xQSoi {
  background-color: #3b82f6;
}

.editUser_bodythemedark__gJc0k .editUser_formbtn__xQSoi:hover {
  background-color: #2563eb;
}

.editUser_bodythemedark__gJc0k .editUser_resetbtn__-wDgG {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.editUser_bodythemedark__gJc0k .editUser_resetbtn__-wDgG:hover {
  background-color: #3b82f6;
}

.editUser_headingdark__CC5Nk span {
  background-color: #132337;
}

.editUser_resetbtn__-wDgG {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.editUser_resetbtn__-wDgG:hover,
.editUser_resetbtn__-wDgG:active,
.editUser_resetbtn__-wDgG:focus {
  background-color: #131F43;
  color: #fff;
}

.editUser_addBtn__UcTNJ {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.editUser_addbtnlight__sNT7u {
  background-color: #38A169;
}

.editUser_addbtndark__mcSQS {
  background-color: #3b82f6;
}

.editUser_addbtndark__mcSQS:hover {
  background-color: #2563eb;
}

.editUser_formthemedark__91io7 label {
  color: #92afd3;
}

.editUser_addBtn__UcTNJ svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.editUser_addBtn__UcTNJ:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.editUser_cust_addBtn__ZO2er.editUser_addBtn__UcTNJ svg {
  top: 2px;
}

.editUser_deleteBtn__BmqwH {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.editUser_deleteBtn__BmqwH {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.editUser_deleteBtn__BmqwH:active, .editUser_deleteBtn__BmqwH:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.editUser_deleteBtn__BmqwH svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.editUser_deleteBtn__BmqwH:hover,
.editUser_deleteBtn__BmqwH:active,
.editUser_deleteBtn__BmqwH:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.editUser_confirmBtn__j\\+4hp {
  background-color: #131F43;
}

.editUser_confirmBtn__j\\+4hp:hover,
.editUser_confirmBtn__j\\+4hp:active,
.editUser_confirmBtn__j\\+4hp:focus {
  background-color: #131F43;
}

.editUser_confirmBtn__j\\+4hp svg {
  top: 0;
}

.editUser_delPopContainer__L9Fi- .editUser_modal-body__oo8y2 {
  padding: 25px;
  text-align: center;
}

.editUser_delPopContainer__L9Fi- .editUser_delet_icon__yZfLN {
  margin-bottom: 11px;
}

.editUser_delPopContainer__L9Fi- p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.editUser_arrowback__8QUpw svg {
  fill: #000;
}

.editUser_bodythemedark__gJc0k .editUser_arrowback__8QUpw {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.editUser_bodythemedark__gJc0k .editUser_arrowback__8QUpw svg {
  fill: #3b82f6;
}

.editUser_bodythemedark__gJc0k .editUser_drpdwn_btn__cYNFI {
  background-color: #132337;
}

.editUser_bodythemedark__gJc0k .editUser_empname__toNaP {
  color: #92afd3 !important;
}

.editUser_bodythemedark__gJc0k .editUser_navitemli__6fUZp a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingsgeneral__nYDeF,
.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingslinks__b\\+cBE:hover {
  background-color: #3b82f6;
  color: #fff;
}

.editUser_bodythemedark__gJc0k .editUser_tabnavli__aOx2v a.editUser_settingslinks__b\\+cBE {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj {
  background-color: #1c2e45;
  color: #fff;
}

.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj ul li a,
.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj .editUser_dropdown_item__brbyf,
.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj .editUser_dropdown_item__brbyf h5 {
  color: #fff;
}

.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj ul li a:hover,
.editUser_headerthemedark__1XW9I .editUser_dropdown_menu_contain__aVROj .editUser_dropdown_item__brbyf:hover {
  background-color: #132337;
  color: #fff;
}

.editUser_dropdown_item__brbyf:active {
  background-color: #F5F6FA;
}

.editUser_profile_arrrow_dwn__u62BN {
  stroke: #132337;
}

.editUser_headerthemedark__1XW9I .editUser_profile_arrrow_dwn__u62BN {
  stroke: #fff;
}

.editUser_dateinputbox1__geCZT input,
.editUser_dateinputbox1__geCZT span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .editUser_tableheadlight__t32QY th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .editUser_dashboard__yUISc {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .editUser_cont2__WDGNX {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .editUser_sectionright__4UfRu {
    float: unset !important;
  }
  .editUser_dashboard__yUISc {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .editUser_cont2__WDGNX {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .editUser_bodythemelight__KB6by, .editUser_bodythemedark__gJc0k {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .editUser_exer_modal_contain__07NG8 .editUser_modal-dialog__zyLr5 {
    max-width: 1055px;
  }
  .editUser_delPopContainer__L9Fi- .editUser_modal-dialog__zyLr5 {
    max-width: 350px;
  }
}
#editUser_addform__ovjfH {
  width: 100%;
  border-radius: 5px;
  margin-top: 20px;
}
#editUser_addform__ovjfH #editUser_addheading__9mcyJ {
  font-size: 18px;
  margin-bottom: 20px;
}
#editUser_addform__ovjfH .editUser_inputbox1__XD-nG {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#editUser_addform__ovjfH .editUser_dateinputbox__jSv61 {
  background-color: #F5F6FA;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#editUser_addform__ovjfH .editUser_dateinputbox1__geCZT {
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi {
  background-color: #131F43;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#editUser_addform__ovjfH .editUser_formbtn__xQSoi:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#editUser_addform__ovjfH .editUser_arrowback__8QUpw:hover {
  background-color: #39979d;
  color: #fff;
}
#editUser_addform__ovjfH ::placeholder {
  font-size: 14px;
  color: #60677e;
}

@media only screen and (max-width: 600px) {
  #editUser_dashboardcont2__yX3nJ {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/editUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AAnsBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAqsBJ;AAnsBI;EACI,eAAA;EACA,mBAAA;AAqsBR;AAlsBI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDkCc;ECjCd,WD2CM;ACypBd;AAjsBI;EACI,yBDPC;ECQD,kBAAA;EACA,WAAA;EACA,cDqCM;ECpCN,eAAA;AAmsBR;AAjsBI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDmBc;EClBd,WD4BM;ACuqBd;AAhsBI;EACI,yBDqCW;ECpCX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAksBR;AAhsBQ;EACI,2CD6BS;ACqqBrB;AA9rBI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAgsBR;AA9rBU;EACE,yBAAA;EACA,WAAA;AAgsBZ;AA5rBI;EACI,eAAA;EACA,cDFS;ACgsBjB;;AAvrBE;EACE;IACI,wBDgBI;ICfJ,UDgBG;ICfH,kBAAA;IACA,aDQW;ECkrBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 20px;\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;\n         \n    }\n    .dateinputbox{\n        background-color: $mainBg; \n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;\n    }\n    \n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n\n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n\n  }\n  \n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `editUser_dashboard__yUISc`,
	"dashboardContain": `editUser_dashboardContain__GtVNk`,
	"bodythemedark": `editUser_bodythemedark__gJc0k`,
	"cont2": `editUser_cont2__WDGNX`,
	"top_header": `editUser_top_header__7A80O`,
	"top_header_inner": `editUser_top_header_inner__2GMP0`,
	"footer": `editUser_footer__arSK6`,
	"bodythemelight": `editUser_bodythemelight__KB6by`,
	"headerthemelight": `editUser_headerthemelight__RcR6X`,
	"headerthemedark": `editUser_headerthemedark__1XW9I`,
	"menuthemelight": `editUser_menuthemelight__93STk`,
	"menuthemedark": `editUser_menuthemedark__yR0K2`,
	"menulinklight": `editUser_menulinklight__T1Ugp`,
	"menulinkdarkSelected": `editUser_menulinkdarkSelected__bZWxL`,
	"menulinklightSelected": `editUser_menulinklightSelected__LxANp`,
	"menulinkdark": `editUser_menulinkdark__4Mzbh`,
	"sub_arrow": `editUser_sub_arrow__valJj`,
	"headinglight": `editUser_headinglight__iYkug`,
	"headingdark": `editUser_headingdark__CC5Nk`,
	"searchboxlight": `editUser_searchboxlight__JtJHv`,
	"searchboxdark": `editUser_searchboxdark__c8WH1`,
	"tableheadlight": `editUser_tableheadlight__t32QY`,
	"tableheaddark": `editUser_tableheaddark__IU1BY`,
	"table": `editUser_table__UBG50`,
	"table-borderless": `editUser_table-borderless__vgOBj`,
	"left-section": `editUser_left-section__5Ygpr`,
	"tablebodylight": `editUser_tablebodylight__xGR7k`,
	"tablebodydark": `editUser_tablebodydark__ANb75`,
	"paginationlight": `editUser_paginationlight__UynJG`,
	"paginationdark": `editUser_paginationdark__EfSxZ`,
	"formthemelight": `editUser_formthemelight__+6R3K`,
	"formthemedark": `editUser_formthemedark__91io7`,
	"viewformlight": `editUser_viewformlight__y32+k`,
	"permissionboxlight": `editUser_permissionboxlight__uvNqc`,
	"permissionboxdark": `editUser_permissionboxdark__bgl1b`,
	"errormsgclr": `editUser_errormsgclr__vFQxR`,
	"graphclrlight": `editUser_graphclrlight__0tGaV`,
	"graphclrdark": `editUser_graphclrdark__Oe4fN`,
	"card1bglight": `editUser_card1bglight__kUxQl`,
	"card1bgdark": `editUser_card1bgdark__tfYHD`,
	"card2bglight": `editUser_card2bglight__ZXiVd`,
	"card2bgdark": `editUser_card2bgdark__O1gIJ`,
	"card3bglight": `editUser_card3bglight__xkw1U`,
	"card3bgdark": `editUser_card3bgdark__FCvDO`,
	"card4bglight": `editUser_card4bglight__pic05`,
	"card4bgdark": `editUser_card4bgdark__oir3Z`,
	"actionbtnlight": `editUser_actionbtnlight__3hMAT`,
	"actionbtndark": `editUser_actionbtndark__c1n4B`,
	"profiledropdownlight": `editUser_profiledropdownlight__zqmBO`,
	"profiledropdowndark": `editUser_profiledropdowndark__WK9BI`,
	"settingsection": `editUser_settingsection__qkXU0`,
	"addform": `editUser_addform__ovjfH`,
	"savebtn": `editUser_savebtn__RGuGY`,
	"profile_conatiner": `editUser_profile_conatiner__4m7UK`,
	"ag-theme-alpine": `editUser_ag-theme-alpine__hlul9`,
	"ag-row": `editUser_ag-row__uJXdt`,
	"formbtn": `editUser_formbtn__xQSoi`,
	"resetbtn": `editUser_resetbtn__-wDgG`,
	"addBtn": `editUser_addBtn__UcTNJ`,
	"addbtnlight": `editUser_addbtnlight__sNT7u`,
	"addbtndark": `editUser_addbtndark__mcSQS`,
	"cust_addBtn": `editUser_cust_addBtn__ZO2er`,
	"deleteBtn": `editUser_deleteBtn__BmqwH`,
	"confirmBtn": `editUser_confirmBtn__j+4hp`,
	"delPopContainer": `editUser_delPopContainer__L9Fi-`,
	"modal-body": `editUser_modal-body__oo8y2`,
	"delet_icon": `editUser_delet_icon__yZfLN`,
	"arrowback": `editUser_arrowback__8QUpw`,
	"drpdwn_btn": `editUser_drpdwn_btn__cYNFI`,
	"empname": `editUser_empname__toNaP`,
	"navitemli": `editUser_navitemli__6fUZp`,
	"tabnavli": `editUser_tabnavli__aOx2v`,
	"settingsgeneral": `editUser_settingsgeneral__nYDeF`,
	"settingslinks": `editUser_settingslinks__b+cBE`,
	"dropdown_menu_contain": `editUser_dropdown_menu_contain__aVROj`,
	"dropdown_item": `editUser_dropdown_item__brbyf`,
	"profile_arrrow_dwn": `editUser_profile_arrrow_dwn__u62BN`,
	"dateinputbox1": `editUser_dateinputbox1__geCZT`,
	"sectionright": `editUser_sectionright__4UfRu`,
	"exer_modal_contain": `editUser_exer_modal_contain__07NG8`,
	"modal-dialog": `editUser_modal-dialog__zyLr5`,
	"addheading": `editUser_addheading__9mcyJ`,
	"inputbox1": `editUser_inputbox1__XD-nG`,
	"dateinputbox": `editUser_dateinputbox__jSv61`,
	"dashboardcont2": `editUser_dashboardcont2__yX3nJ`
};
export default ___CSS_LOADER_EXPORT___;
